<template>
    <div 
        :class="['search-attr-modal-mask', bModalEffectMask ? 'fade-in':'fade-out']" 
        @touchmove.prevent 
        @click.self="closeSearchModal()"
        v-show="bModalMaskShow"
    >
        <transition name="collapse-list">  
            <div class="search-attr-modal" v-show="bSearchModalShow">
                <div class="search-attr-header">
                    <div class="search-input-wrap">
                        <div class="area-select">
                            <span>上海市</span>
                            <div class="arrow-b"></div>
                        </div>
                        <input type="text" name="" id="">
                    </div>
                    <img src="@/assets/images/ant/map/search_icon2.png" alt="">
                </div>
                <div class="search-attr-content">
                    <div class="attr-item">
                        <div class="label">房屋面积：</div>
                        <ul class="tab-list">
                            <li class="active">80-120㎡</li>
                            <li>80-120㎡</li>
                            <li>80-120㎡</li>
                            <li>80-120㎡</li>
                        </ul>
                    </div>
                    <div class="attr-item">
                        <div class="label">房屋类型：</div>
                        <ul class="tab-list">
                            <li class="active">一室</li>
                            <li>二室</li>
                            <li>三室</li>
                        </ul>
                    </div>
                    <div class="attr-item">
                        <div class="label">房屋种类：</div>
                        <ul class="tab-list">
                            <li class="active">别墅</li>
                            <li>太平层</li>
                            <li>其他</li>
                        </ul>
                    </div>
                    <div class="attr-item">
                        <div class="label">产品品类：</div>
                        <ul class="tab-list">
                            <li class="active">冷暖风水</li>
                            <li>采暖</li>
                            <li>水系统</li>
                        </ul>
                    </div>
                    <div class="attr-item">
                        <div class="label">案例进度：</div>
                        <ul class="tab-list">
                            <li class="active">已签约</li>
                            <li>施工中</li>
                            <li>已完工</li>
                        </ul>
                    </div>
                    <div class="attr-item">
                        <div class="label">装修：</div>
                        <ul class="tab-list">
                            <li class="active">新装</li>
                            <li>改装</li>
                        </ul>
                    </div>
                </div>
                <div class="search-attr-btn">
                    <button class="clear-btn">清空条件</button>
                    <button class="confirm-btn">确定</button>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'searchModal',
    components:{

    },
    data() {
        return {
            bModalEffectMask:false, // 动画开关
            bModalMaskShow:false // mask开关
        }
    },
    props: {
        bSearchModalShow: {
            type: Boolean,
            default: false
        }
    },
    filters:{
        
    },
    created() {
        
    },
    mounted(){
        
    },
    computed:{
        
    },
    watch:{
        bSearchModalShow(newValue, oldValue ) {
            if (newValue) {
                this.bModalMaskShow = newValue
                this.bModalEffectMask = newValue
            } else {
                this.bModalEffectMask = newValue
                setTimeout(() => {
                    this.bModalMaskShow = newValue
                }, 500)
            }
        }
    },
    methods:{
        closeSearchModal() {
            // this.$emit('update:bSearchModalShow', false)
        }
    }
    

}
</script>

<style lang="scss" scoped>
    .search-attr-modal-mask{
        width: 100%;
        height: calc(100vh - 110px);
        position: absolute;
        top: 110px;
        left: 0;
        z-index: 888;
        background-color: rgba(0,0,0,0.4);
        .search-attr-modal{
            width: 100%;
            background-color: #fff;
            padding: 50px 30px;
            .search-attr-header{
                display: flex;
                align-items: center;
                & > img{
                    width: 58px;
                    height: 59px;
                    flex-shrink: 0;
                    margin-left: 15px;
                }
                .search-input-wrap{
                    border: 1Px solid rgb(38, 50, 102);
                    width: 618px;
                    height: 66px;
                    display: flex;
                    .area-select{
                        background-color: rgb(38, 50, 102);
                        width: 174px;
                        height: 100%;   
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-shrink: 0;
                        span{
                            font-size: 30px;
                            color: rgb(255, 255, 255);                         
                        }   
                        .arrow-b{
                            background: url("~@/assets/images/ant/map/arrow_s.png") top/100% auto no-repeat;
                            width: 21px;
                            height: 10px;
                            flex-shrink: 0;
                            margin-left: 10px;
                        }              
                    }
                    input{
                        flex-grow: 1;
                        height: 100%;
                        padding: 5px 15px;
                    }
                }
                img{

                }
            }
            .search-attr-content{
                margin-top: 30px;
                .attr-item{
                    margin-bottom: 15px;
                    display: flex;
                    .label{
                        width: 150px;
                        font-size: 30px;
                        color: rgb(45, 45, 45);
                        font-weight: bold;
                        flex-shrink: 0;
                        text-align: right;
                    }
                    .tab-list{
                        flex-grow: 1;
                        display: flex;
                        flex-wrap: wrap;
                        li{
                            min-width: 130px;
                            text-align: center;
                            font-size: 30px;
                            color: rgb(150, 150, 150);   
                            padding: 5px;   
                            margin: 0 20px 20px 20px;                   
                        }
                        .active{
                            border-radius: 5px;
                            background-color: rgba(38, 50, 102, 0.2);
                            color:  rgb(38, 50, 102);                     
                        }
                    }
                }
            }
            .search-attr-btn{
                padding: 0 10px;
                display: flex;
                justify-content: space-between;
                .clear-btn{
                    border-radius: 5px;
                    background-color: #f0a400;
                    width: 300px;
                    height: 80px;   
                    font-size: 32px;
                    color: rgb(255, 255, 255);             
                }
                .confirm-btn{
                    border-radius: 5px;
                    background-image: linear-gradient( 180deg, rgb(45,82,150) 0%, rgb(38,63,121) 31%, rgb(30,44,92) 100%);
                    width: 300px;
                    height: 80px;
                    font-size: 32px;
                    color: rgb(255, 255, 255);
                }
            }
        }
    }
    .collapse-enter-active {
        transition: all .8s ease;
    }
    .collapse-leave-active {
        transition: all .8s ease;
    }
    .collapse-enter, .collapse-leave-to {
        transform: translateY(500px);
    }

    .collapse-list-enter-active {
        transition: all .5s ease;
    }
    .collapse-list-leave-active {
        transition: all .5s ease;
    }
    .collapse-list-enter, .collapse-list-leave-to {
        transform: translateY(-500px);
    }

    .fade-in {
        animation: fadeIn .5s ease forwards;
    }
    .fade-out {
        animation: fadeOut .5s ease forwards;
    }
    @keyframes fadeIn {
        0% {
            opacity: 0;
        }

        100% {
            opacity: 1;
        }
    }
    @keyframes fadeOut {
        0% {
            opacity: 1;
        }

        100% {
            opacity: 0;
        }
    }
</style>